export const updateHyperVergeTokenReducer = {
  updateHyperVergeToken: (state, action) => {
    console.log('updateHyperVergeToken called', action.payload);
    state.hypervergeToken = action.payload;
  },
};
